<template>
    <div>
        <img src="@/assets/images/coursepage/video-placeholder-fi.jpg" :alt="$t('NoVideo.coming_soon')" v-if="$totemLang === 'fi'"/>
        <img src="@/assets/images/coursepage/video-placeholder-fi.jpg" :alt="$t('NoVideo.coming_soon')" v-if="!$totemLang || $totemLang === 'en'"/>
        <img src="@/assets/images/coursepage/video-placeholder-fi.jpg" :alt="$t('NoVideo.coming_soon')" v-if="$totemLang === 'se'"/>
        <img src="@/assets/images/coursepage/video-placeholder-fi.jpg" :alt="$t('NoVideo.coming_soon')" v-if="$totemLang === 'no'"/>
        <img src="@/assets/images/coursepage/video-placeholder-dk.jpg" :alt="$t('NoVideo.coming_soon')" v-if="$totemLang === 'dk'"/>
    </div>
</template>

<script>
    export default {
        name: 'NoVideo'
    }
</script>

<style scoped>
    img {
        width: 100%;
        border-radius: 10px;
    }
</style>
